import { BaseTenantSearch } from '@/services/_base/BaseTenantSearch'
import type { Agent } from '@/types/Agent'
import type { IFirestoreService } from '@/platform/firebase/firestore'

type Session = { tenantId?: string; yardId?: string; userId?: string }

export class AgentSearch extends BaseTenantSearch<Agent> {
  constructor(session: Session, firestore: IFirestoreService) {
    super('agents', session, 'agent.search', firestore)
  }

  // Get only enabled agents
  active() {
    this.where('enabled', '==', true)
    this.appendToMetaName('active')
    return this
  }

  // Get all agents (enabled and disabled)
  all() {
    this.appendToMetaName('all')
    return this
  }

  // Search by name
  byName(name: string) {
    this.where('meta.name', '>=', name)
    this.where('meta.name', '<=', name + '\uf8ff')
    this.appendToMetaName('byName')
    return this
  }

  // Order by creation date
  byCreatedAt(dir: 'asc' | 'desc' = 'desc') {
    this.orderBy('meta.createdAt', dir)
    this.appendToMetaName('byCreatedAt')
    return this
  }

  // Order by last seen
  byLastSeen(dir: 'asc' | 'desc' = 'desc') {
    this.orderBy('meta.lastSeenAt', dir)
    this.appendToMetaName('byLastSeen')
    return this
  }
}
